<template>
Pong
</template>
  
  <script>
  export default {
    name: "ping"
  };
  </script>
  